export default "__VITE_ASSET__F3boZ7_4__"